import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'antd';
import type { ModalProps } from 'antd';

type Point = { x: number; y: number };

export default function DraggableModal({ title, open, ...props }: ModalProps) {
  const shellRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<Point>({ x: 0, y: 0 });

  useEffect(() => {
    if (!open) setPosition({ x: 0, y: 0 });
  }, [open]);

  const beginDrag = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.button !== 0 || !shellRef.current) return;
    event.preventDefault();
    const rect = shellRef.current.getBoundingClientRect();
    const startMouseX = event.clientX;
    const startMouseY = event.clientY;
    const startPosition = position;
    const bounds = {
      minX: position.x - rect.left + 12,
      maxX: position.x + window.innerWidth - rect.right - 12,
      minY: position.y - rect.top + 12,
      maxY: position.y + window.innerHeight - rect.bottom - 12,
    };
    const onMove = (move: MouseEvent) => setPosition({
      x: clamp(startPosition.x + move.clientX - startMouseX, bounds.minX, bounds.maxX),
      y: clamp(startPosition.y + move.clientY - startMouseY, bounds.minY, bounds.maxY),
    });
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  };

  return (
    <Modal
      {...props}
      open={open}
      title={<div onMouseDown={beginDrag} style={{ cursor: 'move', userSelect: 'none', paddingRight: 32 }}>{title}</div>}
      modalRender={(modal) => <div ref={shellRef} style={{ transform: `translate(${position.x}px, ${position.y}px)` }}>{modal}</div>}
    />
  );
}

function clamp(value: number, minimum: number, maximum: number) {
  return Math.min(Math.max(value, minimum), maximum);
}
